import React from "react"

import PackageTableIcon from "./CellContent/Icon"
import PackageTableStars from "./CellContent/Stars"
import PackageTableText from "./CellContent/Text"

const PackageTableCell = ({ cell }) => {
  const {
    model: { apiKey },
    icons,
    starAmount,
    text,
  } = cell

  switch (apiKey) {
    case "package_table_cell_text":
      return <PackageTableText text={text} />
    case "package_table_cell_star":
      return <PackageTableStars starAmount={starAmount} />
    case "package_table_cell_icon":
      return <PackageTableIcon icons={icons} />

    default:
      return null
  }
}

export default PackageTableCell
